import React from 'react';
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import Heading from './Heading';
import { Education_Resources } from '../Data/E_Offer';

const slugify = (value = "") =>
    value
        .toString()
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, "")
        .replace(/[\s_-]+/g, "-")
        .replace(/^-+|-+$/g, "");

const Resource = ({
    maxItems = null,
    resources = Education_Resources,
    subHeading = 'Learning Categories',
    heading = 'Educational Resources by Discipline',
}) => {
     const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2,
                duration: 0.8
            }
        }
    };
    const displayedResources = maxItems
        ? resources.slice(0, maxItems)
        : resources;

  return (
     <motion.section 
            className="main-lwbl bg-[#F9FAFB] py-16 px-[0.5rem] overflow-hidden h-[100%] "
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-50px" }}
            variants={containerVariants}
        >
             <Heading subHeading={subHeading}  heading={heading}
             />
         
         <div className="flex justify-center items-center gap-[1rem] py-[2rem] px-[1rem] flex-wrap">
            {displayedResources.map((resource)=>(
                 <Link
                    className='group relative block w-[350px] h-[450px] rounded-4xl overflow-hidden focus:outline-none focus:ring-4 focus:ring-cyan-300'
                    key={resource.id}
                    to={`/refine/${slugify(resource.title)}`}
                    aria-label={`Open ${resource.title} details`}
                 > 
                     <img src={resource.image} alt={resource.title}  style={{width:"100%", height:"100%",objectFit:"cover" ,borderRadius:"30px"}}/>
                     <div className="absolute inset-0 rounded-[30px] bg-gradient-to-t from-black/75 via-black/15 to-transparent transition group-hover:from-black/82" />
                     <div className="
                        absolute bottom-0 left-0 w-full py-4 px-4 rounded-t-2xl text-white
                        "
                         >
                         <h3 className='font-cinzel text-2xl font-normal'>{resource.title}</h3>
                         <p className='font-outfit text-lg font-light'>{resource.detail}</p>
                         <p className="mt-4 font-outfit text-xs font-semibold uppercase tracking-[0.18em] text-[#00F0FB]">
                            View details
                         </p>
                     </div>
                 </Link>
            ))}
         </div>


      </motion.section>
  )
}

export default Resource
